/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

/* eslint-disable promise/always-return */
/* eslint-disable promise/catch-or-return */

import { useIdentityGatewayServiceStore } from 'dxpConsoleCore-mf/State';
import { getBaseServiceConfig } from '../../../../_base';
import { IdentityGatewayService } from '../../IdentityGateway.service';
import { IdentityGatewayServiceConfiguration } from '../../IdentityGateway.service.config';

/**
 * Get the Identity Gateway Service.
 */
export const getIdentityGatewayService = (): IdentityGatewayService => {
  const baseServiceConfig = getBaseServiceConfig();

  const { updateIdentityGatewayService } = useIdentityGatewayServiceStore.getState();
  const { identityGatewayService }: { identityGatewayService: IdentityGatewayService | null } =
    useIdentityGatewayServiceStore.getState();

  if (!identityGatewayService) {
    const serviceConfig: IdentityGatewayServiceConfiguration = baseServiceConfig;
    const newService = new IdentityGatewayService(serviceConfig);
    updateIdentityGatewayService(newService);

    return newService;
  }

  return identityGatewayService;
};
